<a
  class="text-link-content"
  [routerLink]="url"
  [queryParams]="queryParams"
  [class.disable]="!url"
  [class.archived]="state === TrainingAvailability.ARCHIVED"
>
  @if (state === TrainingAvailability.ARCHIVED) {
    <mat-icon class="size-sm">archive</mat-icon>
  }
  @if (text && text.length < 80) {
    <span>{{ text }}</span>
  }
  @if (text && text.length >= 80) {
    <span [matTooltip]="text" [matTooltipPosition]="'above'">{{
      trimText(text)
    }}</span>
  }
  <mat-icon class="text-link-icon">call_received</mat-icon>
</a>
